import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import getRoutes from "./routes";
import NotFoundPage from "./NotFoundPage";
import AuthService from "../../Application/User/AuthService";
import Layout from "./Layout";

import { useTranslation } from "react-i18next";


function ProtectedRoutes() {
  return AuthService.isAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to={process.env.PUBLIC_URL + "/login"} />
  );
}

export default function PrivateApp() {
  const { t } = useTranslation();

  return (
    <Layout>
      <Routes>
        <Route element={<ProtectedRoutes />}>
          {getFlattenRoutes().map((element, index) => (
            <Route
              key={index}
              path={element.path}
              element={
              <>
                <h1>{t(`TITLE.PAGE.${element.key}`)}</h1>
                { element.component }
              </>  
              }
            />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Layout>
  );
}

function getFlattenRoutes() {
  const flattenRoutes = [];
  getRoutes().forEach((route) => {
    flattenRoutes.push(route);
    if (route.children && route.children.length > 0) {
      route.children.forEach((childRoute) => {
        flattenRoutes.push(childRoute);
      });
    }
  });
  return flattenRoutes;
}
